var $ = require('jQuery');
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');

module.exports = function()
{
    new IndexView();
    new Columnator();

    // Score set selector
    $('#scoreSetSelector').on("change", function() {
        var data = 'score-set=' + $(this).val();
        var url  = $(this).data('url');
        $.pjax({url: url, data: data, container: '#pjaxContainer', method: 'GET'});
    });
};
